var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-main',{staticClass:"mt-0 pt-0",staticStyle:{"height":"100%"}},[_c('enrollment-header',{attrs:{"header":_vm.appHeader}}),(_vm.isAdmin)?_c('enrollment-navigation-drawer',{attrs:{"items":_vm.items}}):_vm._e(),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }